import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import Container from './Container';

const Desc = styled.p`
	text-align: center;
	font-family: ${props => props.theme.f2};
	font-size: 2rem;
	font-weight: 400;
	padding: 0;
	margin: 0 auto;

	${rmq('t')} {
		max-width: 63rem;
		padding: 0 1rem;
	}
	${rmq('ml')} {
		font-size: 1.3rem;
		padding: 0 1rem;
	}
`;

export default ({ children }) => (
	<Container>
		<Desc>{children}</Desc>
	</Container>
);
